import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import FacebookIcon from '@/assets/svg/FacebookIcon'
import TwitterIcon from '@/assets/svg/TwitterIcon'
import YoutubeIcon from '@/assets/svg/YoutubeIcon'

import MobileFooterAddress from '../../MobileFooterAddress'

const getCurrentYear = () => new Date().getFullYear()

export default function Footer() {
  return (
    <footer className="footer shadow-bg" id="ve-kiotviet">
      <div className="container">
        <div className="row">
          <div className="col-6 col-lg-3 footer-list">
            <h3 className="footer-title">Doanh nghiệp</h3>
            <ul>
              <div
                id="header-widget-area"
                className="chw-widget-area widget-area"
                role="complementary"
              >
                <div className="chw-widget">
                  <div className="textwidget">
                    <ul>
                      <li>
                        <Link
                          title="Về chúng tôi"
                          href="https://www.kiotviet.vn/ve-ki-ot-viet/"
                          rel="nofollow"
                        >
                          Về chúng tôi
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Khách hàng"
                          href="https://www.kiotviet.vn/khach-hang/"
                          rel="nofollow"
                        >
                          Khách hàng
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Điều khoản sử dụng"
                          href="https://www.kiotviet.vn/dieu-khoan-su-dung/"
                          rel="nofollow"
                        >
                          Điều khoản sử dụng
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Chính sách bảo mật"
                          href="https://www.kiotviet.vn/chinh-sach-bao-mat/"
                          rel="nofollow"
                        >
                          Chính sách bảo mật
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Liên hệ"
                          href={process.env.NEXT_PUBLIC_REACT_APP_LENDING_FORM || '#'}
                          rel="nofollow"
                        >
                          Liên hệ
                        </Link>
                      </li>
                      <li>
                        Email:{' '}
                        <Link
                          title="Email"
                          href="mailto:hotro@kiotviet.com"
                          rel="nofollow"
                        >
                          hotro@kiotviet.com
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </ul>
            <h3 className="footer-title">Tư vấn bán hàng</h3>
            <h3 className="mb-0 footer-contact">
              <Link href="tel:1800 6162">1800 6162</Link>
            </h3>
          </div>
          <div className="col-6 col-lg-3 col-md-6 footer-list">
            <h3 className="footer-title">Hỗ trợ</h3>
            <ul>
              <div
                id="header-widget-area"
                className="chw-widget-area widget-area"
                role="complementary"
              >
                <div className="chw-widget">
                  <div className="textwidget">
                    <ul>
                      <li>
                        <Link
                          title="Video hướng dẫn sử dụng"
                          href="https://www.youtube.com/c/HDSDPhanmemKiotViet"
                          rel="nofollow"
                        >
                          Video hướng dẫn sử dụng
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Câu hỏi thường gặp"
                          href="https://www.kiotviet.vn/ho-tro/#faqs"
                          rel="nofollow"
                        >
                          Câu hỏi thường gặp
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Wiki KiotViet"
                          href="https://www.kiotviet.vn/wiki-ki-ot-viet/"
                          rel="nofollow"
                        >
                          Wiki KiotViet
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Hướng dẫn sử dụng"
                          href="https://www.kiotviet.vn/huong-dan-su-dung-kiotviet/"
                          rel="nofollow"
                        >
                          Hướng dẫn sử dụng
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Blog"
                          href="https://www.kiotviet.vn/blog/"
                          rel="nofollow"
                        >
                          Blog
                        </Link>
                      </li>
                      <li>
                        <Link
                          title="Thông tin cập nhật Kiotviet"
                          href="https://www.kiotviet.vn/noi-dung-cap-nhat-sap-toi/"
                        >
                          Thông tin cập nhật Kiotviet
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </ul>
            <h3 className="footer-title">Chăm sóc khách hàng</h3>
            <h3 className="mb-0 footer-contact">
              <Link href="tel:1900 6522">1900 6522</Link>
            </h3>
          </div>
          <div className="col-12 col-lg-6 footer-list">
            <h3 className="footer-title">Giải pháp ngành hàng</h3>
            <div className="chw-widget">
              <div className="textwidget">
                <ul className="row">
                  <li className="col-6">
                    <Link
                      title="Thời trang"
                      href="https://www.kiotviet.vn/phan-mem-ban-hang-thoi-trang"
                    >
                      Thời trang
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Nông sản &amp; Thực phẩm"
                      href="https://www.kiotviet.vn/nong-san-thuc-pham/"
                    >
                      Nông sản &amp; Thực phẩm
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Bar - Cafe, Nhà hàng, Karaoke &amp; Billiards"
                      href="https://www.kiotviet.vn/bar-cafe-nha-hang/"
                    >
                      Bar – Cafe, Nhà hàng, Karaoke &amp; Billiards
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Vật liệu xây dựng"
                      href="https://www.kiotviet.vn/vat-lieu-xay-dung/"
                    >
                      Vật liệu xây dựng
                    </Link>
                  </li>

                  <li className="col-6">
                    <Link
                      title="Tạp hóa &amp; Siêu thị mini"
                      href="https://www.kiotviet.vn/phan-mem-ban-hang-tap-hoa"
                    >
                      Tạp hóa &amp; Siêu thị mini
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Xe, Máy móc &amp; linh kiện Sửa chữa"
                      href="https://www.kiotviet.vn/linh-kien-may-moc/"
                    >
                      Xe, Máy móc &amp; linh kiện Sửa chữa
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Điện thoại &amp; Điện máy"
                      href="https://www.kiotviet.vn/dien-thoai-dien-may/"
                    >
                      Điện thoại &amp; Điện máy
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Mẹ &amp; Bé"
                      href="https://www.kiotviet.vn/me-be/"
                    >
                      Mẹ &amp; Bé
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Nội thất &amp; Gia dụng"
                      href="https://www.kiotviet.vn/noi-that/"
                    >
                      Nội thất &amp; Gia dụng
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Hoa &amp; Quà tặng"
                      href="https://www.kiotviet.vn/hoa-qua-tang/"
                    >
                      Hoa &amp; Quà tặng
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Nhà thuốc"
                      href="https://www.kiotviet.vn/phan-mem-quan-ly-nha-thuoc"
                    >
                      Nhà thuốc
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Sách &amp; Văn phòng phẩm"
                      href="https://www.kiotviet.vn/sach-van-phong-pham/"
                    >
                      Sách &amp; Văn phòng phẩm
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Mỹ phẩm"
                      href="https://www.kiotviet.vn/phan-mem-quan-ly-ban-hang-my-pham"
                    >
                      Mỹ phẩm
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Hair Salon, Nails, Massage &amp; Spa"
                      href="https://www.kiotviet.vn/spa-salon-massage-nails/"
                    >
                      Hair Salon, Nails, Massage &amp; Spa
                    </Link>
                  </li>
                  <li className="col-6">
                    <Link
                      title="Ngành hàng khác"
                      href="https://www.kiotviet.vn/nganh-hang-khac/"
                    >
                      Ngành hàng khác
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-address-website">
          <div className="footer-address">
            <h3 className="footer-title">Địa chỉ Miền Bắc</h3>
            <div className="chw-widget">
              <div className="textwidget">
                <div className="row">
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Hà Nội</p>
                    <p className="mb-0">Tầng 3-6, số 1A Yết Kiêu, phường Cửa Nam, thành phố Hà Nội</p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Hải Phòng</p>
                    <p className="mb-0">176A Tôn Đức Thắng, phường An Biên, thành phố Hải Phòng</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 256 509 126">
                        02 256 509 126
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Quảng Ninh</p>
                    <p className="mb-0">
                      Số 19 Cao Xanh, phường Cao Xanh, tỉnh Quảng Ninh
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0203 629 6060">
                        0203 629 6060
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Thái Nguyên</p>
                    <p className="mb-0">
                      Số 174 đường Bắc Sơn, phường Phan Đình Phùng, tỉnh Thái Nguyên
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0866 482 168">
                        0866 482 168
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Nam Định</p>
                    <p className="mb-0">
                      Số 110 Trần Huy Liệu, phường Trường Thi, tỉnh Nam Định
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0981 374 268">
                        0981 374 268
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Phú Thọ</p>
                    <p className="mb-0">
                      Số 514 Châu Phong, phường Việt Trì, tỉnh Phú Thọ
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 102 486 699">
                        02 102 486 699
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Hải Dương</p>
                    <p className="mb-0">
                      32 Hồng Quang, phường Hải Dương, thành phố Hải Dương
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0220 2601 666">
                        0220 2601 666
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Bắc Ninh</p>
                    <p className="mb-0">
                      Số 56 Nguyễn Gia Thiều, phường Kinh Bắc, tỉnh Bắc Ninh
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0222 222 6688">
                        0222 222 6688
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-address">
            <h3 className="footer-title">Địa chỉ Miền Trung</h3>
            <div className="chw-widget">
              <div className="textwidget">
                <div className="row">
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Đà Nẵng</p>
                    <p className="mb-0">
                      110 Đống Đa, phường Hải Châu, thành phố Đà Nẵng
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 366 523 966">
                        02 366 523 966
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Khánh Hòa</p>
                    <p className="mb-0">
                      1053 đường 2/4, phường Nha Trang, tỉnh Khánh Hòa
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0901 903 866">
                        0901 903 866
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Nghệ An</p>
                    <p className="mb-0">
                      Số 28 Nguyễn Sỹ Sách, phường Thành Vinh, tỉnh Nghệ An
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 386 668 168">
                        02 386 668 168
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Đắk Lắk</p>
                    <p className="mb-0">72 Ngô Quyền, phường Buôn Ma Thuột, tỉnh Đắk Lắk</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0943 748 181">
                        0943 748 181
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Thanh Hóa</p>
                    <p className="mb-0">
                      Lô 15 Đội Cung, phường Hạc Thành, tỉnh Thanh Hóa
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 376 546 688">
                        02 376 546 688
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Thừa Thiên Huế</p>
                    <p className="mb-0">138 Trường Chinh, phường An Cựu, thành phố Huế</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 346 542 468">
                        02 346 542 468
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Bình Định</p>
                    <p className="mb-0">136 Chương Dương, phường Quy Nhơn Nam, tỉnh Gia Lai</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 566 527 662">
                        02 566 527 662
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Gia Lai</p>
                    <p className="mb-0">44A Phù Đổng, phường Pleiku, tỉnh Gia Lai</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0869 561 268">
                        0869 561 268
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Lâm Đồng</p>
                    <p className="mb-0">186 Hai Bà Trưng, phường Cam Ly - Đà Lạt, tỉnh Lâm Đồng</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0868 435 268">
                        0868 435 268
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Bình Thuận</p>
                    <p className="mb-0">
                      J46 Tôn Đức Thắng, phường Hàm Thắng, tỉnh Lâm Đồng
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0252 6299 299">
                        0252 6299 299
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Quảng Ngãi</p>
                    <p className="mb-0">
                      Số 165 Lê Lợi, phường Cẩm Thành, tỉnh Quảng Ngãi
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 556 538 899">
                        02 556 538 899
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-address">
            <h3 className="footer-title">Địa chỉ Miền Nam</h3>
            <div className="chw-widget">
              <div className="textwidget">
                <div className="row">
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">TP.HCM</p>
                    <p className="mb-0">
                      Tầng 8 khu B-C, Tòa nhà Waseco Số 10 Phổ Quang, phường Tân Sơn Hòa, thành phố Hồ Chí Minh
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Cần Thơ</p>
                    <p className="mb-0">
                      Số 199 Võ Văn Kiệt, phường Bình Thủy, thành phố Cần Thơ
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0292 6502 777">
                        0292 6502 777
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Vũng Tàu</p>
                    <p className="mb-0">492A đường 30/4, phường Rạch Dừa, thành phố Hồ Chí Minh</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02 542 210 888">
                        02 542 210 888
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Kiên Giang</p>
                    <p className="mb-0">
                      L2 C11 Phan Thị Ràng, phường Rạch Giá, tỉnh An Giang
                    </p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:02972 200 168">
                        02972 200 168
                      </Link>
                    </p>
                  </div>
                  <div className="address-item col-lg-3 col-md-6">
                    <p className="province mb-0">Đồng Tháp</p>
                    <p className="mb-0">Số 05 Đặng Văn Bình, phường Cao Lãnh, tỉnh Đồng Tháp</p>
                    <p className="mb-0">
                      Hotline:{' '}
                      <Link className="color-hyper" href="tel:0277 6277 666">
                        0277 6277 666
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-address-mobile">
          <MobileFooterAddress />
        </div>
      </div>
      <div className="box-social-website">
        <div className="box-social">
          <div className="container">
            <div className="box-social-wrap">
              <p className="mb-0 p-0 flex">
                <span>
                  <Link
                    href="https://www.dmca.com/Protection/Status.aspx?ID=e9fda70b-1262-49c8-9689-028aa2d238c5&amp;refurl=https://www.kiotviet.vn/"
                    title="DMCA.com Protection Status"
                    className="dmca"
                  >
                    <Image
                      src="./images/DMCA.jpg"
                      width={112}
                      height={16}
                      alt="DMCA"
                    />{' '}
                  </Link>
                </span>
                <span>{getCurrentYear()} KiotViet™</span> © Copyright 2010-{getCurrentYear()} KiotViet Corporation. All Right Reserved
              </p>
              <ul className="social">
                <li>
                  <Link
                    rel="nofollow"
                    title="Facebook"
                    href="https://facebook.com/PhanmembanhangKiotViet"
                    target="_blank"
                  >
                    <FacebookIcon />
                  </Link>
                </li>
                <li>
                  <Link
                    rel="nofollow"
                    title="Twitter"
                    href="https://twitter.com/KiotViet"
                    target="_blank"
                  >
                    <TwitterIcon />
                  </Link>
                </li>
                <li>
                  <Link
                    rel="nofollow noopener noreferrer"
                    title="Youtube"
                    href="https://www.youtube.com/channel/UCDLpNUxdUx7E81MV4K7ocxA"
                    target="_blank"
                  >
                    <YoutubeIcon />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="box-social-mobile">
        <div className="container">
          <div className="box-social-wrap">
            <ul className="social">
              <li>
                <Link
                  rel="nofollow"
                  title="Facebook"
                  href="https://facebook.com/PhanmembanhangKiotViet"
                  target="_blank"
                >
                  <FacebookIcon />
                </Link>
              </li>
              <li>
                <Link
                  rel="nofollow"
                  title="Twitter"
                  href="https://twitter.com/KiotViet"
                  target="_blank"
                >
                  <TwitterIcon />
                </Link>
              </li>
              <li>
                <Link
                  rel="nofollow noopener noreferrer"
                  title="Youtube"
                  href="https://www.youtube.com/channel/UCDLpNUxdUx7E81MV4K7ocxA"
                  target="_blank"
                >
                  <YoutubeIcon />
                </Link>
              </li>
            </ul>
            <p className="footer-copyright">
              <span>© Copyright 2010-{getCurrentYear()} KiotViet Corporation</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
